import { instance, next } from "./base";

export const addAdmin = async (values) => {
  const { data } = await instance()
    .post("/api/v1/admin/signup", values)
    .catch((e) => next(e));
  return data?.data;
};

export const fetchAdmins = async (search) => {
  const { data } = await instance()
    .get("/api/v1/admin", { params: { limit: 30, ...(search && { search }) } })
    .catch((e) => next(e));
  return data?.data;
};

export const loginAdmin = async (values) => {
  const { data } = await instance()
    .post("/api/v1/admin/login", values)
    .catch((e) => next(e));
  return data?.data;
};

export const updateAdminStatus = async ({ id, isActive }) => {
  const { data } = await instance()
    .patch(`/api/v1/admin/${id}/status`, { isActive })
    .catch((e) => next(e));
  return data?.data;
};
